import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClusterRoutingModule } from './cluster-routing.module';

import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { ClusterComponent } from './cluster/cluster.component';
import { ClusterDataComponent } from './cluster-data/cluster-data.component';
import { ClusterDataTableComponent } from './cluster-data-table/cluster-data-table.component';
import { ClusterUpdateUsuryThresholdDialogComponent } from './cluster-update-usury-threshold-dialog/cluster-update-usury-threshold-dialog.component';
import { ClusterDetailComponent } from './cluster-detail/cluster-detail.component';
import { ClusterVersionDialogComponent } from './cluster-version-dialog/cluster-version-dialog.component';
import { ClusterDeleteTanMaxDialogComponent } from './cluster-delete-tan-max-dialog/cluster-delete-tan-max-dialog.component';

@NgModule({
  declarations: [
    ClusterComponent,
    ClusterDataComponent,
    ClusterDataTableComponent,
    ClusterUpdateUsuryThresholdDialogComponent,
    ClusterDetailComponent,
    ClusterVersionDialogComponent,
    ClusterDeleteTanMaxDialogComponent,
  ],
  imports: [
    CommonModule,
    ClusterRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatDialogModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
})
export class ClusterModule {}
